import { render, staticRenderFns } from "./HomeStandings.vue?vue&type=template&id=34028917&scoped=true&"
import script from "./HomeStandings.vue?vue&type=script&lang=js&"
export * from "./HomeStandings.vue?vue&type=script&lang=js&"
import style0 from "./HomeStandings.vue?vue&type=style&index=0&id=34028917&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34028917",
  null
  
)

export default component.exports